import npyjs from 'npyjs';

export default (_, inject) => {
  const npy = new npyjs();
  inject('npy', npy);
};
